import { RouterModule, Routes } from '@angular/router';
import { ShellModule } from './shell/shell.module';
import { PageNotFoundComponent } from './shell/page-not-found/page-not-found.component';
import { LoginModule } from './login/login.module';

const routes: Routes = [
    { path: '', loadChildren: () => ShellModule },
    { path: 'login', loadChildren: () => LoginModule },
    { path: '**', component: PageNotFoundComponent }
 ];

export const appRouting = RouterModule.forRoot(routes);
